(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.ZUGAirFreshenerDealRecipes = api;
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  var RECIPES = {
    '50FOR99': {
      key: '50FOR99',
      activationTag: 'ZUG_AF_DEAL:50FOR99',
      quantity: 50,
      baseTotalCents: 9900,
      unitCents: 198,
      lockQuantity: true,
      fragranceLimit: 1,
      turnaround: { key: 'standard', label: 'Standard' },
      printStyles: {
        mirrored: { label: 'Single Mirrored Image', surchargeCents: 0 },
        double: { label: 'Double Image', surchargeCents: 2000 }
      }
    },
    'BOGO': {
      key: 'BOGO',
      activationTag: 'ZUG_AF_DEAL:BOGO',
      sourceProductId: 7565869219903,
      sourceProductHandle: 'custom-air-fresheners-bogo',
      minimumPaidQuantity: 1,
      maximumPaidQuantity: 5,
      freePiecesPerPaidPiece: 1
    }
  };

  function positiveInteger(value) {
    var number = Number(value);
    return Number.isInteger(number) && number > 0 ? number : 0;
  }

  function normalizeTags(input) {
    var values = Array.isArray(input) ? input : String(input || '').split('||');
    return values.map(function (value) { return String(value || ''); }).filter(Boolean);
  }

  function copyRecipe(recipe) {
    var copy = {
      key: recipe.key,
      activationTag: recipe.activationTag
    };
    if (recipe.key === '50FOR99') {
      copy.quantity = recipe.quantity;
      copy.baseTotalCents = recipe.baseTotalCents;
      copy.unitCents = recipe.unitCents;
      copy.lockQuantity = recipe.lockQuantity;
      copy.fragranceLimit = recipe.fragranceLimit;
      copy.turnaround = Object.assign({}, recipe.turnaround);
      copy.printStyles = {
        mirrored: Object.assign({}, recipe.printStyles.mirrored),
        double: Object.assign({}, recipe.printStyles.double)
      };
    } else if (recipe.key === 'BOGO') {
      copy.sourceProductId = recipe.sourceProductId;
      copy.sourceProductHandle = recipe.sourceProductHandle;
      copy.minimumPaidQuantity = recipe.minimumPaidQuantity;
      copy.maximumPaidQuantity = recipe.maximumPaidQuantity;
      copy.freePiecesPerPaidPiece = recipe.freePiecesPerPaidPiece;
    }
    return copy;
  }

  function validate(recipe) {
    if (!recipe || !/^[A-Z0-9]+$/.test(String(recipe.key || '')) ||
        recipe.activationTag !== 'ZUG_AF_DEAL:' + recipe.key) {
      throw new Error('Air Freshener deal recipe is invalid.');
    }
    if (recipe.key === 'BOGO') {
      if (positiveInteger(recipe.sourceProductId) !== 7565869219903 ||
          recipe.sourceProductHandle !== 'custom-air-fresheners-bogo' ||
          positiveInteger(recipe.minimumPaidQuantity) !== 1 ||
          positiveInteger(recipe.maximumPaidQuantity) !== 5 ||
          positiveInteger(recipe.freePiecesPerPaidPiece) !== 1) {
        throw new Error('Air Freshener BOGO recipe is invalid.');
      }
      return recipe;
    }
    if (recipe.key !== '50FOR99' ||
        positiveInteger(recipe.quantity) !== 50 ||
        positiveInteger(recipe.baseTotalCents) !== 9900 ||
        positiveInteger(recipe.unitCents) !== 198 ||
        recipe.quantity * recipe.unitCents !== recipe.baseTotalCents ||
        recipe.lockQuantity !== true || positiveInteger(recipe.fragranceLimit) !== 1 ||
        !recipe.turnaround || recipe.turnaround.key !== 'standard' ||
        recipe.turnaround.label !== 'Standard' || !recipe.printStyles ||
        !recipe.printStyles.mirrored || recipe.printStyles.mirrored.label !== 'Single Mirrored Image' ||
        recipe.printStyles.mirrored.surchargeCents !== 0 ||
        !recipe.printStyles.double || recipe.printStyles.double.label !== 'Double Image' ||
        positiveInteger(recipe.printStyles.double.surchargeCents) !== 2000) {
      throw new Error('Air Freshener deal recipe is invalid.');
    }
    return recipe;
  }

  function validateQuantity(recipe, quantityValue) {
    validate(recipe);
    var quantity = positiveInteger(quantityValue);
    if (recipe.key === 'BOGO') {
      if (quantity < recipe.minimumPaidQuantity || quantity > recipe.maximumPaidQuantity) {
        throw new Error('Air Freshener BOGO quantity must be from 1 to 5 paid pieces.');
      }
      return quantity;
    }
    if (quantity !== recipe.quantity) throw new Error('Air Freshener deal quantity is locked.');
    return quantity;
  }

  function productionQuantities(recipe, paidQuantityValue) {
    var paidQuantity = validateQuantity(recipe, paidQuantityValue);
    var freeQuantity = recipe.key === 'BOGO'
      ? paidQuantity * recipe.freePiecesPerPaidPiece
      : 0;
    return {
      paid: paidQuantity,
      free: freeQuantity,
      total: paidQuantity + freeQuantity
    };
  }

  Object.keys(RECIPES).forEach(function (key) { validate(RECIPES[key]); });

  function resolve(tags) {
    var exactTags = normalizeTags(tags);
    var matches = Object.keys(RECIPES).filter(function (key) {
      return exactTags.indexOf(RECIPES[key].activationTag) !== -1;
    });
    if (matches.length > 1) throw new Error('Multiple Air Freshener deal recipes matched.');
    return matches.length === 1 ? copyRecipe(RECIPES[matches[0]]) : null;
  }

  function pricing(recipe, quantityValue) {
    validate(recipe);
    if (recipe.key !== '50FOR99') {
      throw new Error('Air Freshener BOGO pricing requires the product price contract.');
    }
    var quantity = validateQuantity(recipe, quantityValue);
    return {
      qty: quantity,
      unitCents: recipe.unitCents,
      unitPrice: recipe.unitCents / 100,
      totalCents: recipe.baseTotalCents,
      total: recipe.baseTotalCents / 100
    };
  }

  function quote(recipe, input) {
    input = input || {};
    var base = pricing(recipe, input.quantity);
    var fragranceCount = positiveInteger(input.fragranceCount);
    if (!fragranceCount || fragranceCount > recipe.fragranceLimit) {
      throw new Error('Air Freshener deal allows exactly one fragrance.');
    }
    var printStyle = String(input.printStyle || '');
    var printRecipe = recipe.printStyles[printStyle];
    if (!printRecipe) throw new Error('Air Freshener deal print style is invalid.');
    return {
      quantity: base.qty,
      unitCents: base.unitCents,
      baseTotalCents: base.totalCents,
      fragranceCents: 0,
      doubleImageCents: printStyle === 'double' ? printRecipe.surchargeCents : 0,
      totalCents: base.totalCents + printRecipe.surchargeCents,
      turnaround: recipe.turnaround.label
    };
  }

  function productRow(recipe) {
    validate(recipe);
    return {
      productId: 0,
      handle: '',
      kind: 'deal',
      pricingMode: 'deal_exact',
      quantities: [recipe.quantity],
      unitCents: [recipe.unitCents],
      presets: [recipe.quantity],
      allowCustomQuantity: false,
      customQuantityPolicy: null,
      packaging: 'none',
      dealRecipe: recipe
    };
  }

  return {
    recipes: Object.keys(RECIPES).reduce(function (output, key) {
      output[key] = copyRecipe(RECIPES[key]);
      return output;
    }, {}),
    resolve: resolve,
    validate: validate,
    pricing: pricing,
    quote: quote,
    productRow: productRow,
    validateQuantity: validateQuantity,
    productionQuantities: productionQuantities
  };
});
